import { apiClient } from "./apiClient";
import { ITrangThaiDangKyAn } from "../models/response/category/ITrangThaiDangKyAn";

export const TRANG_THAI_DANG_KY_AN_API_END_POINT = "trang-thai-dang-ky-an";

export const trangThaiDangKyAnApi = {
    selectAll: () => apiClient.get(TRANG_THAI_DANG_KY_AN_API_END_POINT),
    selectById: (id: number) => apiClient.get(`${TRANG_THAI_DANG_KY_AN_API_END_POINT}/${id}`),
    insert: (data: ITrangThaiDangKyAn) => apiClient.post(TRANG_THAI_DANG_KY_AN_API_END_POINT, data),
    update: (data: ITrangThaiDangKyAn) => apiClient.put(TRANG_THAI_DANG_KY_AN_API_END_POINT, data),
    delete: (id: number) => apiClient.delete(`${TRANG_THAI_DANG_KY_AN_API_END_POINT}/${id}`)
};
